import { inspectionsService } from '@/services/inspections';
import type { InspectionStatus } from '@/services/inspections/types';
import { STALE_TIME_FIVE_MINUTES_MS } from '@/shared/constants/query-stale-time.constants';
import { useQuery } from '@tanstack/react-query';

export function useInspectionStatuses() {
  return useQuery<InspectionStatus[]>({
    queryKey: ['inspection-statuses'],
    queryFn: async () => {
      const response = await inspectionsService.getInspectionStatuses();

      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar status de inspeção'
        );
      }

      return response.data;
    },
    staleTime: STALE_TIME_FIVE_MINUTES_MS,
  });
}
